export class OwnershipFilter {
    ownerships: string[];

    constructor(ownerships: string) {
        this.ownerships = JSON.parse(ownerships);
    }

    getOwnerships(): string[] {
        return this.ownerships;
    }

    addOwnerships(companyNameList: string[]) {
        this.ownerships = companyNameList;
    }

    removeOwnerships(companyNameList: string[]) {
        companyNameList.forEach(companyName => {
            this.ownerships = this.ownerships.filter(ownership => ownership !== companyName);
        });
    }

    isAtLeastOneOwnershipFilterActive(): boolean {
        return this.ownerships.length > 0;
    }

}